import React, { useState } from "react";

const SkillBar = ({ value, color, skillsLevelHandler, indexArray }) => {
  // const [value, setValue] = useState(initialValue);
  const [hoverValue, setHoverValue] = useState(null);
  console.log(value, "valuevalue");
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // width: "300px",
  };

  const barContainerStyle = {
    // width: "160px",
    height: "20px",
    backgroundColor: "#e0e0e0",
    display: "flex",
    overflow: "hidden",
    cursor: "pointer",
    marginRight: "10px",
  };

  const sectionStyle = (sectionIndex) => ({
    flex: 1,
    height: "100%",
    backgroundColor: sectionIndex < (hoverValue ?? value) ? color : "#e0e0e0",
    transition: "background-color 0.2s ease-in-out",
    marginLeft: sectionIndex === 0 ? "0" : "-1px", // Overlap slightly to hide the gap
  });

  const handleMouseEnter = (index) => {
    setHoverValue(index + 1);
  };

  const handleMouseLeave = () => {
    setHoverValue(null);
  };

  const handleClick = (index) => {
    const newValue = index + 1;
    // setValue(newValue);
    if (skillsLevelHandler) {
      skillsLevelHandler(newValue, indexArray); // Notify parent component of the new value
    }
  };

  return (
    <div style={containerStyle}>
      <div style={barContainerStyle} className="skillbar_new">
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            style={sectionStyle(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(index)}
          ></div>
        ))}
      </div>
      <span style={{ color: color, width: "19px" }}>{value}</span>
    </div>
  );
};

export default SkillBar;
